import { createFeatureSelector, createSelector } from '@ngrx/store';

import { HierarchyNodesResults } from '®shared/hierarchy';

import {
  HierarchyAndStudentNumbers,
  HierarchyAndStudentNumbersTransfer,
} from '../common';

export const STATE_FEATURE_NODES_EDITOR = 'nodesEditor';

export interface NodeSearchState {
  searchTerm: string | null;
  searchResults: HierarchyNodesResults | null;
  isLoading: boolean;
  error: any | null;
}

export const NODE_SEARCH_INITIAL_STATE: NodeSearchState = {
  searchTerm: null,
  searchResults: null,
  isLoading: false,
  error: null,
};

export interface NewListHierarchyEditorState {
  listId?: string;
  isDraft: boolean;
  hierarchyAndStudentNumbers: HierarchyAndStudentNumbers;
  isLoading: boolean;
  isSaving: boolean;
  loadingError: any | null;
  savingError: any | null;
}

export interface SavedListHierarchyEditorState
  extends NewListHierarchyEditorState {
  listId: string;
}

export type HierarchyEditorState =
  | SavedListHierarchyEditorState
  | NewListHierarchyEditorState;

export interface NodesEditorModalState {
  isModalShown: boolean;
  hierarchyEditor: HierarchyEditorState | null;
}

export interface NodesEditorState {
  nodeEditorModal: NodesEditorModalState;
  search: NodeSearchState;
}

export const HIERARCHY_EDITOR_INITIAL_STATE: NewListHierarchyEditorState = {
  isDraft: true,
  hierarchyAndStudentNumbers: {
    listStudentNumbers: null,
    nodesAndOverrides: null,
    initialStatus: HierarchyAndStudentNumbersTransfer.NoTransfer,
  },
  isLoading: false,
  isSaving: false,
  loadingError: null,
  savingError: null,
};

export const NODES_EDITOR_MODAL_INITIAL_STATE: NodesEditorModalState = {
  isModalShown: false,
  hierarchyEditor: HIERARCHY_EDITOR_INITIAL_STATE,
};

export const NODES_EDITOR_INITIAL_STATE: NodesEditorState = {
  nodeEditorModal: NODES_EDITOR_MODAL_INITIAL_STATE,
  search: NODE_SEARCH_INITIAL_STATE,
};

export function getInitialNodesEditorState(): NodesEditorState {
  return NODES_EDITOR_INITIAL_STATE;
}

export const selectNodesEditorState = createFeatureSelector<NodesEditorState>(
  STATE_FEATURE_NODES_EDITOR,
);

export const selectNodeSearchState = createSelector(
  selectNodesEditorState,
  (state: NodesEditorState) => state.search,
);

export const selectNodeEditorModalState = createSelector(
  selectNodesEditorState,
  (state: NodesEditorState) => state.nodeEditorModal,
);

export const selectHierarchyAndStudentNumbersState = createSelector(
  selectNodesEditorState,
  (state: NodesEditorState) =>
    state.nodeEditorModal.hierarchyEditor?.hierarchyAndStudentNumbers,
);
